<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">MEDICAL SERVICE AND PROCEDURE(Outpatient)</h3>
            <div class="img-wrap">
                <img alt="" class="" src="/resource/img/">
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">For patients visiting for the first time</h3>
            <h4 class="depth bullet02">Getting medical service today without making an appointment in advance</h4>
            <p class="depth">
                Please fill out the service application form provided from the basement - 3rd floor. Get a number ticket and show the service application form, your health insurance card, and your ID to the reception counter where your number is displayed. Then, an outpatient service reservation certificate and a medical examination card will be issued for you. Submit the outpatient service reservation certificate to the outpatient department.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">For patients with previous visiting history</h3>
            <h4 class="depth bullet02">Reservation made at the previous visit</h4>
            <p class="depth">Please arrive approximately 10 minutes earlier than the scheduled time and come directly to the department.</p>
            <p class="depth">Submit the reservation certificate to the department you are visiting.</p>
            <h4 class="depth bullet02">Reservation made via phone or online (phone, internet, mobile device)</h4>
            <p class="depth">Please arrive approximately 10 minutes earlier than the scheduled time and come directly to the department.</p>
            <p class="depth">Please show your reservation guide text message to the reception counter of the department.</p>
            <h4 class="depth bullet02">Getting medical service today without making an appointment in advance</h4>
            <p class="depth">Get a number ticket and show the service application form and your health insurance card to the reception counter where your number is displayed. Then, an outpatient service reservation certificate will be issued for you. Submit the outpatient service reservation certificate to the department.</p>
            <p class="depth font-sub">※ Service without an advance reservation can be closed early depending on the circumstances of the department.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>